import React, {Component} from 'react'
import PropTypes from 'prop-types'
import StatusStyle from '../../../../shared/StatusStyle'

class BasketStatus extends Component {
    render() {
        return (
            <td className='BasketStatus'>
                <StatusStyle status={this.props.status}/>
            </td>
        )
    }
}

BasketStatus.propTypes = {
    status: PropTypes.string.isRequired,
}

export default BasketStatus
